import { LocalStorage, saveStorage } from '@/common/util/storage'

import LoginForm from '@/components/container/form/modules/login/LoginForm'
import LoginPageLayout from '@/components/container/page/login/LoginPageLayout'

const LoginPage = () => {
  return (
    <LoginPageLayout>
      <LoginForm
        onRequested={(response) => {
          saveStorage(LocalStorage.AUTH_TOKEN, response.token)
          window.location.reload()
        }}
      />
    </LoginPageLayout>
  )
}

export default LoginPage
